import { action, computed, observable, runInAction } from "mobx";
import { ApiResult, FieldType, ViewModelBase } from "@shoothill/core";
import moment, { Moment } from "moment";

// App
import { DashboardApplicationModel } from "Globals/Models/Domain/Dashboard/DashboardApplicationModel";

export default class DashboardApplicationViewModel extends ViewModelBase<DashboardApplicationModel> {
    constructor(application: DashboardApplicationModel) {
        super(application);
    }

    @computed
    private get lastSavedMoment(): Moment {
        return moment.utc(this.model.lastSavedDate);
    }

    @computed
    public get lastSaved(): string {
        return this.lastSavedMoment ? this.lastSavedMoment.local().format("HH:mm - DD/MM/YYYY") : "";
    }
    @computed
    private get submittedMoment(): Moment {
        return moment.utc(this.model.submittedDate);
    }

    @computed
    public get submittedDate(): string {
        return this.submittedMoment ? this.submittedMoment.local().format("HH:mm - DD/MM/YYYY") : "";
    }

    public async isFieldValid(fieldName: keyof FieldType<DashboardApplicationModel>, value: any): Promise<boolean> {
        // let { isValid, errorMessage } = await this.validateDecorators(fieldName);

        // this.setError(fieldName, errorMessage);
        // this.setValid(fieldName, isValid);

        // return isValid;
        return true;
    }
    public afterUpdate: undefined;
    public beforeUpdate: undefined;
}
